import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface ICliniciansCheckboxProps {
    targetClinicians: CheckboxTarget;
    targetDeactivatedClinicians: CheckboxTarget;
    operationClinicianCheckedChange: number;
    operationClinicianDeactivatedChange: number;
    checkedClinicians: boolean;
    checkedDeactivatedClinicians: boolean;
}

class CliniciansCheckBoxControl extends React.Component<ICliniciansCheckboxProps, never> {
    public render(): JSX.Element {
        return (
            <div style={{ display: "inline-flex", marginRight: "50px" }}>
                <label htmlFor="clinicians_id" className="uppercase" style={{ width: "100px" }} title={cacheStore.GetString("CliniciansLabel").toUpperCase()}>
                    <input type="checkbox" id="clinicians_id" onChange={this.onCliniciansCheckChange.bind(this)} checked={this.props.checkedClinicians} />
                    {" " + cacheStore.GetString("CliniciansLabel")}
                </label>

                <label htmlFor="DeactivatedClinicians_id" className="uppercase" style={{ width: "150px" }}>
                    <input type="checkbox" id="DeactivatedClinicians_id" onChange={this.onDeactivatedCliniciansCheckChange.bind(this)} checked={this.props.checkedDeactivatedClinicians} style={{ marginLeft: "10px" }} />
                    {" " + cacheStore.GetString("DeactivatedMLabel")}
                </label>
            </div>
        );
    }

    public onDeactivatedCliniciansCheckChange(e: React.ChangeEvent<HTMLInputElement>): void {
        var operation = new LocalEvent(this.props.operationClinicianCheckedChange);
        operation.AddItem("target", this.props.targetDeactivatedClinicians);
        operation.AddItem("checked", e.target.checked);
        LocalEventDispatcher.dispatch(operation);
    }

    public onCliniciansCheckChange(e: React.ChangeEvent<HTMLInputElement>): void {
        var operation = new LocalEvent(this.props.operationClinicianDeactivatedChange);
        operation.AddItem("target", this.props.targetClinicians);
        operation.AddItem("checked", e.target.checked);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { CliniciansCheckBoxControl };
